import React, { useState } from 'react';
import '../../css/gardenPlanterStylings/PlotPlanterStyling.css';
import PlotPlanterAutoPlantingPanel from './PlotPlanterAutoPlantingPanel';
import PlotPlanterGarden from "./PlotPlanterGarden";
import {useAuth} from "../../hooks/useAuth";
import { saveGardenToDB, saveGardenPlantsToDB  } from "../lib/gardenServices";

const PlotPlanter = ({ gardenName, gardenInformation, gardenSavedToDB}) => {

    const [isManualMode, setIsManualMode] = useState(false);

    // users planted map, so we can preserve like tomato in the middle and whatnot
    const [plantMapping, setPlantMapping] = useState({});

    //preview algorithm changes
    const [algoMapping, setAlgoMapping] = useState({});


    // db needed auth
    const {user} = useAuth();

    // saving garden to the user db
    const saveToDB = async (plantMap) => {
        if (!user) {
            console.error("Not logged in");
            throw new Error("Not logged in"); // Throw error instead of just returning
        }

        try {
            // First save the garden
            const { error: gardenError, gardenId } = await saveGardenToDB({
                name: gardenName,
                soil_type: gardenInformation.gardenInfo.soilType,
                hardiness_zone: gardenInformation.gardenInfo.hardiness,
                sunlight: gardenInformation.gardenInfo.sunlight,
                maintenance: gardenInformation.gardenInfo.maintenance,
                matrix: gardenInformation.gardenInfo.matrix,
            });

            if (gardenError) {
                console.error("Error saving garden:", gardenError);
                throw new Error("Failed to save garden");
            }

            // Then save the plants if we have a plant map and garden ID
            if (plantMap && plantMap.length > 0 && gardenId) {
                const flatPlantMap = plantMap.flat();

                const { error: plantsError, plantsCount } = await saveGardenPlantsToDB({
                    gardenId: gardenId,
                    plantMap: flatPlantMap,
                    gardenWidth: plantMap[0]?.length || 25
                });

                if (plantsError) {
                    console.error("Error saving plants:", plantsError);
                    throw new Error("Failed to save plants");
                } else {
                    console.log(`Successfully saved ${plantsCount} plants`);
                    gardenSavedToDB(gardenName);
                }
            } else if (!gardenId) {
                throw new Error("No garden ID returned, cannot save plants");
            } else if (!plantMap || plantMap.length === 0) {
                console.log("No plants to save - plantMap is empty");
            }
        } catch (error) {
            console.error("Error in saveToDB:", error);
            throw error; // Re-throw so the calling component can handle it
        }
    };

    const manualClickHandler = () => {
        setIsManualMode(true)
    }

    const autoClickHandler = () => {
        setIsManualMode(false);
    }

    // gets the most updated MANUALLY planted garden from the plot planter garden
    const handleUpdatingPlantMap = (data) => {
        // console.log(gardenInformation);
        setPlantMapping(data);
    };

    // updates from algo output -> garden visual output
    const handleAutoPlantingAlgorithmChange = (data) => {
        // console.log("Received planted garden:", data);
        // console.log(gardenInformation.plants);
        setAlgoMapping(data);
    };

    const handlePlotPlanterClear = () => {
        setAlgoMapping({});
    }

    const handleSaveGardenToDB = async (data) => {
        return await saveToDB(data);
    }

    return (
        // <div className={`planter-garden-card ${selected ? 'selectedGarden' : ''}`}> </div>

        <div className={`plot-planter-container`}>
            <div className={`plot-planter-header`}>
                <h3>Auto-planting options:</h3>
            </div>

            {/*<div className={`plot-planter-planting-styles`}>*/}
            {/*    <button className={`plot-planter-button ${isManualMode && (`active`)}`} onClick={manualClickHandler}>Manual Planting</button>*/}
            {/*    <button className={`plot-planter-button ${!isManualMode && (`active`)}`} onClick={autoClickHandler}>Auto-Planting</button>*/}
            {/*</div>*/}

            {!isManualMode && (
                <div className={`plot-planter-auto-planting-panel`}>
                    <PlotPlanterAutoPlantingPanel gardenInformation={gardenInformation} algorithmPreview={handleAutoPlantingAlgorithmChange} handleClear={handlePlotPlanterClear}/>
                </div>
            )}

            <PlotPlanterGarden gardenMatrix={gardenInformation.gardenInfo.matrix} plants={gardenInformation.plants}
                               autoPlantingActive={!isManualMode} updateMap={handleUpdatingPlantMap}
                               algoPreviewChange={algoMapping} saveGardenClick={handleSaveGardenToDB}/>
        </div>
    );
};

export default PlotPlanter;